import { CategorizeByColumn } from './draggable-input-modal/type';
import {
  CategoryItem,
  ColumnRename,
  KanbanProspectListPayload,
  UpdateKanbanViewPayload,
} from '../types';

const DEFAULT_CATEGORY_COLOR = '#FEF4F6';

const sanitizeTitle = (title?: string) => {
  const trimmed = title?.trim();
  return trimmed || undefined;
};

export const getFieldLabelById = (
  fields: { id: number; label: string }[] | undefined,
  fieldId?: number | null,
  fallback?: string,
) => {
  if (!fieldId || !fields?.length) {
    return fallback;
  }
  const match = fields.find((field) => field.id === fieldId);
  return match?.label ?? fallback;
};

const sortCategories = (categories: CategoryItem[] = []) =>
  [...categories].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));

export const mapColumnsToCategories = (
  columns: CategorizeByColumn[],
  existingCategories: CategoryItem[] = [],
): { categories: CategoryItem[]; columnRenames: ColumnRename[] } => {
  const sortedExisting = sortCategories(existingCategories);
  const existingMap = new Map<string, CategoryItem>(
    sortedExisting.map((category) => [category.value, category]),
  );

  const columnRenames: ColumnRename[] = [];

  sortedExisting.forEach((category, index) => {
    const candidate = columns[index];
    if (
      candidate &&
      category.value !== candidate.value &&
      !existingMap.has(candidate.value)
    ) {
      columnRenames.push({
        oldValue: category.value,
        newValue: candidate.value,
      });
    }
  });

  const categories: CategoryItem[] = columns.map((column, index) => {
    const fallbackExisting = sortedExisting[index];
    const color =
      column.color ||
      fallbackExisting?.color ||
      existingMap.get(column.value)?.color ||
      DEFAULT_CATEGORY_COLOR;

    return {
      value: column.value,
      color,
      status: column.isHidden ? 0 : 1,
      sortOrder: index + 1,
    };
  });

  return {
    categories,
    columnRenames,
  };
};

export const buildUpdateKanbanPayload = ({
  selectedView,
  categories,
  columnRenames,
  newFieldLabel,
}: {
  selectedView: KanbanProspectListPayload;
  categories: CategoryItem[];
  columnRenames?: ColumnRename[];
  newFieldLabel?: string;
}): UpdateKanbanViewPayload => {
  const payload: UpdateKanbanViewPayload = {
    metadata: {
      // entityType: selectedView?.metadata?.entityType || '',
      categories,
    },
  };

  // if (selectedView?.categoryFieldId !== null && selectedView?.categoryFieldId !== undefined) {
  //   payload.categoryFieldId = selectedView.categoryFieldId;
  // }

  // if (selectedView?.isDefault !== null && selectedView?.isDefault !== undefined) {
  //   payload.isDefault = selectedView.isDefault;
  // }

  if (columnRenames && columnRenames.length > 0) {
    payload.columnRenames = columnRenames;
  }

  const normalizedTitle = sanitizeTitle(newFieldLabel);
  if (normalizedTitle) {
    payload.newFieldLabel = normalizedTitle;
  }

  return payload;
};

export const buildUpdatePayloadFromColumns = ({
  columns,
  selectedView,
  title,
}: {
  columns: CategorizeByColumn[];
  selectedView: KanbanProspectListPayload;
  title?: string;
}) => {
  const { categories, columnRenames } = mapColumnsToCategories(
    columns,
    selectedView?.metadata?.categories || [],
  );

  return buildUpdateKanbanPayload({
    selectedView,
    categories,
    columnRenames,
    newFieldLabel: title,
  });
};
